// /^([-.!#-'*+/-9=?A-Z^-~]{3,61})@([0-9A-Za-z]{2,61}([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]{2,61}))$/;
// TODO move to RegEx folder

export const emailRegEx = /^[a-zA-Z0-9._%+-]+\.?[a-zA-Z0-9._%+-]*@[a-zA-Z0-9._-]+\.[a-z]+$/;
